"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = void 0;

var _styles = require("./styles");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _jsxRuntime = require("react/jsx-runtime");

var TableRow = function TableRow(_ref) {
  var feature = _ref.feature,
      value = _ref.value,
      valueType = _ref.valueType;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      headerType: "table-row-text",
      text: feature
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      headerType: "table-row-text " + (valueType && "gray-table-row"),
      text: value
    })]
  });
};

exports.TableRow = TableRow;